export default "__VITE_ASSET__CpQ53Rwt__"